/**
 * SelectedRun is a run chip attached to the composer. It carries its own
 * entity/project scope so a persisted draft's chip is sent with the scope it
 * was attached under, never re-scoped to whatever route is active on send.
 */
export interface SelectedRun {
  name: string;
  displayName: string;
  entityName: string;
  projectName: string;
}

/**
 * runKey is a run chip's identity.
 *
 * NOTE: Run names are unique only within a project, so the entity/project scope
 * is part of the key — otherwise same-named runs from different projects would
 * collide on add/remove and duplicate as tags.
 */
export function runKey(run: SelectedRun): string {
  return `${run.entityName}/${run.projectName}/${run.name}`;
}
